// Wtyczka natywna `Powiadomienia` aplikacji ze sklepu na Androidzie (telefon/android .../Powiadomienia.java;
// docs/pwa/NATYWNA.md 4, krok 3) - jedna rejestracja dla api/powiadomienia.ts (push) i api/adres.ts (sesja dla
// przycisków w powiadomieniu przy zamkniętej aplikacji).
import { Capacitor, registerPlugin, type PluginListenerHandle } from "@capacitor/core";
import { natywna } from "./instalacja";

/** Dźwięk alarmów krytycznych (Odbiornik.DZWIEKI): budzik z telefonu, nasz albo `telefon` - wybrany w systemowym
 *  oknie wyboru. */
export type DzwiekAlarmu = "budzik" | "syrena" | "pikanie" | "dzwon" | "brzeczyk" | "dwutonowy" | "wycie" | "narastajacy"
  | "dzwonek" | "gong" | "kuranty" | "sonar" | "telefon";

export interface WtyczkaPowiadomien {
  /** `dzwiek`, `przebijCisze`, `dostepCiszy` - od APK 27/28 (starsza aplikacja ich nie podaje); `dzwieki` (dźwięki tej
   *  aplikacji) i `dzwiekNazwa` (nazwa wybranego z telefonu) - od APK z poszerzonym wyborem (01.11). */
  stan(): Promise<{ zgoda: boolean; dostepne: boolean; wylaczone: boolean; dzwiek?: DzwiekAlarmu; dzwieki?: DzwiekAlarmu[];
    dzwiekNazwa?: string; przebijCisze?: boolean; dostepCiszy?: boolean }>;
  /** `telefon` - systemowe okno wyboru: wynik z nazwą, rezygnacja = odmowa `anulowano`. */
  dzwiek(o: { dzwiek: DzwiekAlarmu }): Promise<{ dzwiek?: DzwiekAlarmu; nazwa?: string } | undefined>;
  przebijCisze(o: { wlacz: boolean }): Promise<void>;
  token(o: { pytaj?: boolean; kanaly: Record<string, string> }): Promise<{ token: string }>;
  usun(): Promise<void>;
  sesja(o: { zeton: string; zaplecze: string }): Promise<void>;
  ustawieniaAlarmow(): Promise<void>;
  addListener(zdarzenie: "otwarte", f: (e: { url: string }) => void): Promise<PluginListenerHandle>;
}

export const wtyczkaPowiadomien = registerPlugin<WtyczkaPowiadomien>("Powiadomienia");

/** Aplikacja ze sklepu na Androidzie - push przez wtyczkę (przeglądarka - Web Push). */
export const pushWAplikacji = () => natywna() && Capacitor.getPlatform() === "android";
